import React from 'react'

function Error() {
  return (
    <div>
      <h3>Error: This route was not found.</h3>
    </div>
  )
}

export default Error